import React, { createContext, useContext, useState, useEffect } from 'react';

const TranslationContext = createContext();

const UI_STRINGS = {
  en: {
    'nav.home': 'Home',
    'nav.resources': 'Resources',
    'nav.directory': 'Directory',
    'nav.volunteer': 'Volunteer',
    'nav.caregiver': 'Caregiver Hub',
    'home.hero.title': 'Support for the Journey',
    'home.hero.subtitle': 'A multilingual, moderated platform for cancer patients and caregivers.',
    'home.search.placeholder': 'Search treatments, logistics, or organizations...',
    'footer.mission': 'A multilingual, moderated, volunteer-powered cancer support knowledge platform.',
    'ads.sponsored': 'Sponsored',
    'common.search': 'Search'
  },
  el: {
    'nav.home': 'Αρχική',
    'nav.resources': 'Πηγές',
    'nav.directory': 'Κατάλογος',
    'nav.volunteer': 'Εθελοντισμός',
    'nav.caregiver': 'Κέντρο Φροντιστών',
    'home.hero.title': 'Υποστήριξη στη Διαδρομή',
    'home.hero.subtitle': 'Μια πολύγλωσση, ελεγχόμενη πλατφόρμα για ασθενείς με καρκίνο και φροντιστές.',
    'home.search.placeholder': 'Αναζήτηση θεραπειών, πρακτικής βοήθειας ή οργανισμών...',
    'footer.mission': 'Μια πολύγλωσση, ελεγχόμενη πλατφόρμα γνώσης και υποστήριξης για τον καρκίνο, με τη βοήθεια εθελοντών.',
    'ads.sponsored': 'Χορηγούμενο',
    'common.search': 'Αναζήτηση'
  }
};

export const TranslationProvider = ({ children }) => {
  // Persistence: read from localStorage or default to Greek
  const [uiLanguage, setUiLanguage] = useState(() => {
    return localStorage.getItem('hahub_ui_lang') || 'el';
  });

  const [contentLanguage, setContentLanguage] = useState(() => {
    return localStorage.getItem('hahub_content_lang') || uiLanguage;
  });

  useEffect(() => {
    localStorage.setItem('hahub_ui_lang', uiLanguage);
    document.documentElement.lang = uiLanguage;
  }, [uiLanguage]);

  useEffect(() => {
    localStorage.setItem('hahub_content_lang', contentLanguage);
  }, [contentLanguage]);

  const t = (key) => {
    // Fallback logic: preferred UI lang -> English -> Greek
    const attempt = UI_STRINGS[uiLanguage]?.[key] || 
                    UI_STRINGS['en']?.[key] || 
                    UI_STRINGS['el']?.[key] || 
                    key;
    return attempt;
  };

  return (
    <TranslationContext.Provider value={{ 
      uiLanguage, 
      setUiLanguage, 
      contentLanguage, 
      setContentLanguage, 
      t 
    }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) throw new Error('useTranslation must be used within a TranslationProvider');
  return context;
};